import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Popover,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
// import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
// import { ReactComponent as AddQuestionIcon } from "../../../images/examimage/addquestion.svg";
// import { ReactComponent as AddMarksIcon } from "../../../images/examimage/addmarks.svg";
import { ReactComponent as DashboardIcon } from "../../../images/examimage/dashboard.svg";
import { ReactComponent as ResultIcon } from "../../../images/examimage/result.svg";
import { ReactComponent as PriviewIcon } from "../../../images/examimage/priviewicon.svg";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseIcon from "@material-ui/icons/Close";
import { fetchQuestionPaperApi } from "../../../../service/services";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { ToastContainer, toast } from "react-toastify";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import QuestionPaper from "./QuestionPaper";
import { useReactToPrint } from "react-to-print";

import {
  Edit as EditIcon,
  GetApp as ExportIcon,
  AssignmentTurnedIn as ExportAnswerIcon,
  SwapHoriz as StatusIcon,
  AddCircleOutline as AddQuestionIcon,
  Delete as DeleteIcon,
  Assignment as AddMarksIcon,
} from "@material-ui/icons";

function ViewExam() {
  const classes = useStyles();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [exams, setExams] = useState([]);
  const [visiblePins, setVisiblePins] = useState({});
  const [visiblePinRowId, setVisiblePinRowId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const isMoreMenuOpen = Boolean(moreAnchorEl);
  const [exportWithAnswers, setExportWithAnswers] = useState(false);

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [page, setPage] = useState(0);

  const [questions, setQuestions] = useState([]);
  const componentRef = React.useRef(null);
  const [loadingQuestions, setLoadingQuestions] = useState(false); // ✅ new state

  const fetchQuestionPaper = async () => {
    try {
      setLoadingQuestions(true); // show loader
      const response = await fetchQuestionPaperApi(selectedExamId);
      setQuestions(response.questions);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    } finally {
      setLoadingQuestions(false); // hide loader
    }
  };

  useEffect(() => {
    if (selectedExamId) {
      fetchQuestionPaper();
    }
  }, [selectedExamId]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  const handleOpenPreview = () => setOpenPreview(true);
  const handleClosePreview = () => {
    setSelectedExamId(null);
    setOpenPreview(false);
  };

  const [rowCount, setRowCount] = useState("");
  const handleMoreClick = (event, rowData) => {
    setMoreAnchorEl(event.currentTarget);
    setSelectedRowData(rowData); // ✅ store row info
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleButtonClickQuestion = (type) => {
  //   navigate(`/admin/${type}`);
  // };

  const handleButtonClickQuestion = (type, rowId, score) => {
    // navigate(`/admin/${type}/${rowId}`);
    navigate(`/admin/${type}/${rowId}`, { state: score });
  };

  const togglePinVisibility = (rowId) => {
    setVisiblePinRowId((prev) => (prev === rowId ? null : rowId));
  };

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "AwesomeFileName",
    // onAfterPrint: handleAfterPrint,
    // onBeforePrint: handleBeforePrint,
  });

  const handleButtonClick = (type, rowId) => {
    if (type === "editexam") {
      navigate(`/admin/editexam/${rowId}`);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const fetchData = async (pageNumber, size, search) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/exam`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/exam?page=${
          pageNumber + 1
        }&limit=${size}&search=${search}`,

        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setExams(response.data.exams);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (
      onPage !== undefined &&
      pageSize !== undefined &&
      searchQuery !== undefined
    ) {
      fetchData(onPage, pageSize, searchQuery);
    }
  }, [onPage, pageSize, searchQuery]);

  const handleMoreClose = () => {
    setMoreAnchorEl(null);
  };

  function getBaseUrl() {
    const url = new URL(window.location.href);

    // return `${url.protocol}//192.168.9.62:3000`;

    if (url.hostname === "localhost") {
      return `${url.protocol}//${url.hostname}:3000`;
    } else {
      return `${url.protocol}//${url.hostname}/`.replace("localclient", "exam");
    }
  }

  const handlePreview = async (examId) => {
    const transferData = {
      user_id: "4660",
      exam_id: examId,
    };

    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newWindow = window.open(
      `${getBaseUrl()}?transferKey=${JSON.stringify(transferData)}`,
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`
    );
  };

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log("Exam deleted:", response.data);
      fetchData();
      handleClose();
      toast.success("Exam deleted successfully");
      const updateddatatata = exams.filter((data) => data.id !== rowId);
      setExams(updateddatatata);
    } catch (error) {
      toast.error("Exam is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const data = {
      exam: {
        active_status: newStatus,
        id: iddd,
      },
    };
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/status`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      })
      .then((response) => {
        console.log("Exam status changed successfully", response);
        fetchData();
        toast.success("Exam status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Exam status:", error);
        toast.error("Exam status is not changed");
      });
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_code",
      headerName: "Exam Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "paper_code",
      headerName: "Paper Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "course_name",
      headerName: "Course",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "batch_name",
    //   headerName: "Batch",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 150,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "center_code",
    //   headerName: "Branch Code",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 250,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "no_of_questions",
      headerName: "Questions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "duration",
      headerName: "Duration",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "start_date",
      headerName: "Start Date",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div>
          {new Date(cellValues.row.start_date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
          })}
        </div>
      ),
    },
    {
      field: "start_time",
      headerName: "Start Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "end_time",
      headerName: "End Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_pin",
      headerName: "Exam Pin",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isVisible = visiblePins[cellValues.row.id];
        console.log("cellValues", cellValues);
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" style={{ marginRight: 8 }}>
              {visiblePinRowId === cellValues.row.id
                ? cellValues.row.exam_pin
                : "••••••"}
            </Typography>
            <IconButton
              size="small"
              onClick={() => togglePinVisibility(cellValues.row.id)}
            >
              {visiblePinRowId === cellValues.row.id ? (
                <VisibilityOffOutlinedIcon fontSize="small" />
              ) : (
                <VisibilityOutlinedIcon fontSize="small" />
              )}
            </IconButton>
          </div>
        );
      },
    },
    {
      field: "exam_template",
      headerName: "Exam Template",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "active_status",
      headerName: "STATUS",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            {/* <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton> */}

            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}
              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Disable">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editexam", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 250,
      autoPageSize: false,
      renderCell: (params) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            {/* <IconButton
              onClick={() => {
                handleButtonClickQuestion("addquestion", params.row.id);
              }}
            >
              <LightTooltip title="Add Question">
                <AddQuestionIcon />
              </LightTooltip>
            </IconButton>

            <IconButton
              onClick={() => {
                handleButtonClickQuestion(
                  "addmarks",
                  params.row.id,
                  params.row.total_score
                );
              }}
            >
              <LightTooltip title="Add Marks">
                <AddMarksIcon />
              </LightTooltip>
            </IconButton> */}

            <IconButton
              onClick={() => {
                handleButtonClickQuestion("examdashboard", params.row.id);
              }}
            >
              <LightTooltip title="Dashboard">
                <DashboardIcon />
              </LightTooltip>
            </IconButton>
            <IconButton
              onClick={() => {
                handleButtonClickQuestion("examresult", params.row.id);
              }}
            >
              <LightTooltip title="Result">
                <ResultIcon />
              </LightTooltip>
            </IconButton>
            <IconButton
              onClick={() => {
                // handleButtonClickQuestion("examresult", params.row.id);
                handlePreview(params.row.id);
              }}
            >
              <LightTooltip title="Preview">
                <PriviewIcon />
              </LightTooltip>
            </IconButton>
            <IconButton
              onMouseEnter={(event) => {
                handleMoreClose();
                handleMoreClick(event, params.row);
              }}
              style={{ padding: 0 }}
            >
              <LightTooltip title="More">
                <MoreVertIcon />
              </LightTooltip>
            </IconButton>
            <Menu
              anchorEl={moreAnchorEl}
              open={isMoreMenuOpen}
              onClose={handleMoreClose}
              MenuListProps={{
                onMouseLeave: handleMoreClose,
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                style: {
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)", // light soft shadow
                  borderRadius: "8px",
                  // marginTop: "50px",
                },
              }}
            >
              {/* <MenuItem
                onClick={() => {
                  handleButtonClick("editexam", selectedRowData?.id);
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Edit Exam" />
              </MenuItem>

              <Divider /> */}

              <MenuItem
                onClick={() => {
                  handleButtonClickQuestion("addquestion", selectedRowData?.id);
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <AddQuestionIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Add Question" />
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => {
                  handleButtonClickQuestion(
                    "addmarks",
                    selectedRowData?.id,
                    selectedRowData.total_score
                  );
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <AddMarksIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Add Marks" />
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => {
                  setSelectedExamId(selectedRowData?.id);
                  setExportWithAnswers(false);
                  handleOpenPreview();
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <ExportIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Export Test" />
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => {
                  setSelectedExamId(selectedRowData?.id);
                  setExportWithAnswers(true);
                  handleOpenPreview();
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <ExportAnswerIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Export Test and Answer" />
              </MenuItem>
              {/*
              <Divider />

              <MenuItem
                onClick={() => {
                  handleStatus(
                    selectedRowData?.id,
                    selectedRowData?.active_status
                  );
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <StatusIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Change Status" />
              </MenuItem>

              <Divider />

              <MenuItem
                onClick={() => {
                  deleteDataOfRow(selectedRowData?.id);
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Delete Exam" />
              </MenuItem> */}

              {/* <Divider />

              <MenuItem
                onClick={() => {
                  // deleteExamPermanently(selectedRowData?.id);
                  // setSelectedId(selectedRowData?.id)
                  setIsOpen(true);
                  handleMoreClose();
                }}
              >
                <ListItemIcon>
                  <DeleteIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Delete Permanently" />
              </MenuItem> */}
            </Menu>
          </div>
        );
      },
    },
  ];

  const rows = exams.map((d) => ({
    id: d.id || "N/A",
    exam_name: d.exam_name || "N/A",
    paper_code: d.paper_code || "N/A",
    exam_code: d.exam_code || "N/A",
    course_name: d.course?.length
      ? d.course?.map((cou) => cou?.course_name).join(", ")
      : "N/A",
    batch_name: d.batch?.batch_name || "N/A",
    center_code: d.center?.map((cen) => cen?.center_code).join(", ") || "N/A",
    exam_pin: d.exam_pin || "N/A",
    questions: d.question_count || "N/A",
    duration: d.duration ? `${d.duration} min` : "N/A",
    no_of_questions: d.question_count || "N/A",
    total_score: d.total_score || "N/A",
    start_date: d.start_date || "N/A",
    start_time: d.start_time || "N/A",
    end_time: d.end_time || "N/A",
    exam_template:
      d.exam_template === "ssc/railway" ? "IIT" : d.exam_template || "N/A",
    active_status: d.active_status || "N/A",
  }));
  const startIndex = onPage * pageSize;

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch =
        d.exam_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.course_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.questions
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        d.duration
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        d.total_score
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        d.start_date
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));
  const Heading = [
    {
      id: 1,
      // inputlable: "Select Exam*",
      inputplaceholder: "Search By Exam",
      // export: "yes",
    },
  ];

  const style = [
    {
      style: "viewtable",
      height: "maxh67",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} onSearch={handleSearch} />
        <TableView columns={columns} rows={filteredRows} Heading={style} />
        <Dialog
          open={openPreview}
          onClose={handleClosePreview}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle
            sx={{
              backgroundColor: "#1374aa",
              p: 0, // removes default padding
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: "16px",
                paddingRight: "16px",
                // color: "white",
              }}
            >
              <span>
                {exportWithAnswers ? "Test Paper With Answers" : "Test Paper"}
              </span>
              <IconButton onClick={handleClosePreview} edge="end">
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent dividers>
            <div ref={componentRef} style={{ minHeight: "200px" }}>
              {loadingQuestions ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "200px",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                selectedExamId &&
                questions.length > 0 && (
                  <div>
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "22px",
                        borderBottom: "2px solid black",
                      }}
                    >
                      {
                        exams.filter(
                          (row) => Number(row.id) === Number(selectedExamId)
                        )[0]?.exam_name
                      }
                    </p>

                    <QuestionPaper
                      // paperName={
                      //   rows.filter(
                      //     (row) => Number(row.id) === Number(selectedExamId)
                      //   )[0]?.exam_name
                      // }
                      questions={questions} // ✅ pass data
                      withAnswers={exportWithAnswers}
                    />
                  </div>
                )
              )}
            </div>
          </DialogContent>

          <DialogActions>
            {/* <Button
              className={`${classes.transparentbtn}`}
              onClick={handleClosePreview}
            >
              Close
            </Button> */}
            <Button
              bluebtn
              className={`${classes.bluebtn}`}
              variant="contained"
              color="primary"
              onClick={() => {
                printFn();
                handleClosePreview(); // ✅ print from popup
              }}
            >
              Print
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
export default ViewExam;
